import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInLineRotaryMixer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 190,
	height: 100,
	viewBox: "0 0 190.0 100.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 10,
		y: 0,
		width: 180,
		height: 100,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 50.0 L 190.0 50.0 M 20.0 40.0 L 20.0 10.0 L 85.0 90.0 L 85.0 60.0 M 100.0 40.0 L 100.0 10.0 L 165.0 90.0 L 165.0 60.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgInLineRotaryMixer;
